import { apiClient } from "@/shared/api/client"

export const MCP_SERVER_URL = "https://api.prokmk.ru/mcp"

const MCP_METHOD = "mcp"

export const MCP_SERVER_NAME = "КМК Бэкофис"

const MCP_SERVER_KEY = "kmk-backoffice"

export interface McpClientLinks {
	claude: string
	chatgpt: string
	cursor: string
	vscode: string
	claudeCode: string
}

/** Ссылки «добавить в …» для популярных клиентов: где можно, форма уже заполнена. */
export function buildClientLinks(url = MCP_SERVER_URL): McpClientLinks {
	const claude = new URL("https://claude.ai/settings/connectors")
	claude.searchParams.set("modal", "add-custom-connector")
	claude.searchParams.set("mcpName", MCP_SERVER_NAME)
	claude.searchParams.set("mcpServerUrl", url)
	const cursorConfig = btoa(JSON.stringify({ url }))
	return {
		claude: claude.toString(),
		chatgpt: "https://chatgpt.com/#settings/Connectors",
		cursor: `cursor://anysphere.cursor-deeplink/mcp/install?name=${MCP_SERVER_KEY}&config=${encodeURIComponent(cursorConfig)}`,
		vscode: `vscode:mcp/install?${encodeURIComponent(JSON.stringify({ name: MCP_SERVER_KEY, type: "http", url }))}`,
		claudeCode: `claude mcp add --transport http ${MCP_SERVER_KEY} ${url}`,
	}
}

export interface McpSession {
	id: string
	current: boolean
	method: string | null
	ip: string | null
	userAgent: string | null
	createdAt: string
	lastActiveAt: string
}

export interface ConsentRequest {
	client_id: string
	redirect_uri: string
	response_type: string
	code_challenge: string
	code_challenge_method: string
	state?: string
	scope?: string
	resource?: string
}

export const mcpKeys = { sessions: ["mcp", "sessions"] as const }

export const listMcpSessions = async (): Promise<McpSession[]> => {
	const { data } = await apiClient.get<McpSession[]>("/auth/sessions")
	return data.filter((session) => session.method === MCP_METHOD)
}

export const revokeSession = async (id: string): Promise<void> => {
	await apiClient.delete(`/auth/sessions/${id}`)
}

export const previewConsent = async (
	request: ConsentRequest,
): Promise<{ clientName: string; redirectHost: string; issuer: string }> =>
	(await apiClient.post("/oauth/authorize/preview", request)).data

export const approveConsent = async (request: ConsentRequest): Promise<{ redirectTo: string }> =>
	(await apiClient.post("/oauth/authorize/approve", request)).data

export function readConsentRequest(search: URLSearchParams): ConsentRequest | null {
	const get = (name: string) => search.get(name) ?? undefined
	const required = ["client_id", "redirect_uri", "response_type", "code_challenge"] as const
	if (required.some((name) => !search.get(name))) return null
	return {
		client_id: search.get("client_id") ?? "",
		redirect_uri: search.get("redirect_uri") ?? "",
		response_type: search.get("response_type") ?? "",
		code_challenge: search.get("code_challenge") ?? "",
		code_challenge_method: search.get("code_challenge_method") ?? "",
		state: get("state"),
		scope: get("scope"),
		resource: get("resource"),
	}
}
